export interface IEnvironment {
  baseApiUrl: string;
  baseUrl: string;
}

let currentEnv: IEnvironment = {
  baseApiUrl: import.meta.env.VITE_BASE_API_URL ?? '',
  baseUrl: import.meta.env.VITE_BASE_URL ?? ''
};

export async function loadEnvironment(): Promise<IEnvironment> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) {
      const data = await res.json();
      currentEnv = {
        baseApiUrl: data.baseApiUrl ?? currentEnv.baseApiUrl,
        baseUrl: data.baseUrl ?? currentEnv.baseUrl
      };
    }
  } catch {
    // fallback to import.meta.env
  }
  return currentEnv;
}

export function getEnvironment(): IEnvironment {
  return currentEnv;
}

// Default export via getters: stays up-to-date and is not a mutable export.
const environment = {
  get baseApiUrl() {
    return currentEnv.baseApiUrl;
  },
  get baseUrl() {
    return currentEnv.baseUrl;
  }
} as const;

export default environment;
